import request from "../request";

export const getBrandConfigApi = () => {
  return request.get(`/api/config-center/get-config`);
};

// 获取Enums
const enumsPool = {
  value: null,
  updateAt: 0,
};
const expiredDuration = 1000 * 60 * 60 * 2;
export const getEnums = () => {
  const now = Date.now();
  if (!enumsPool.value || now - enumsPool.updateAt >= expiredDuration) {
    enumsPool.value = request.get(`/api/basic/enums`).catch((error) => {
      enumsPool.value = null;
      return Promise.reject(error);
    });
    enumsPool.updateAt = now;
  }
  return enumsPool.value;
};

export const getEnumByName = (name) =>
  getEnums().then(
    (data) => (data || []).find((item) => item.enumName === name)?.items || []
  );

export const getEnumMap = (name) =>
  getEnumByName(name).then((items) =>
    Object.fromEntries(items.map(({ code, desc }) => [code, desc]))
  );

export const getOrderTypeEnumsApi = (name = "OrderTypeEnum") =>
  getEnumByName(name);
